// snipedOddsService.js
// Service for sniped odds API calls: get all sniped odds, get by player, get by event

import { POST, BASE_URL } from './httpClient';

/**
 * Sniped Odds API functions
 * All endpoints use POST requests and require authentication
 */

// Function to get all sniped odds with optional filters
// Required: type ("price", "overs", or "unders")
// Optional filters: sportType, betType, propTypes (array), isDfs, recommendation, minValueScore, limit
export const getAllSnipedOdds = async (request = {}) => {
    try {
        const response = await POST(`${BASE_URL}/sniped-odds`, request);
        return response; // Return the entire response object
    } catch (error) {
        console.error('Error fetching sniped odds:', error);
        throw error; // Rethrow the error for further handling
    }
};

// Function to get available props for a sport
// Parameters: sport (required)
// Returns: Array of available prop types with display names and counts
export const getAvailableProps = async (sport) => {
    try {
        const response = await POST(`${BASE_URL}/sniped-odds/props`, { sport });
        return response; // Return the entire response object
    } catch (error) {
        console.error('Error fetching available props:', error);
        throw error; // Rethrow the error for further handling
    }
};

// Function to get sportsbook/line options for sniped odds saved in the bet cart
export const getSnipedTicketOptions = async (request = {}) => {
    try {
        return await POST(`${BASE_URL}/sniped-odds/ticket-options`, request);
    } catch (error) {
        console.error('Error fetching sniped ticket options:', error);
        throw error;
    }
};

// Function to get sniped odds for a specific player
// Parameters: sport (required), player (required), limit (optional), sortBy (optional)
export const getSnipedOddsByPlayer = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/sniped-odds/player`, request);
        return response; // Return the entire response object
    } catch (error) {
        console.error('Error fetching sniped odds by player:', error);
        throw error; // Rethrow the error for further handling
    }
};

// Function to get sniped odds for a specific event/game
// Parameters: sport (required), eventId (required), sortBy (optional)
export const getSnipedOddsByEvent = async (request) => {
    try {
        const response = await POST(`${BASE_URL}/sniped-odds/event`, request);
        return response; // Return the entire response object
    } catch (error) {
        console.error('Error fetching sniped odds by event:', error);
        throw error; // Rethrow the error for further handling
    }
};
